/* eslint-disable import/namespace */
import React from 'react'

import * as shapes from './svgs'

export default function Icon({ theme, ...props }) {
  if (!props.svg || !shapes[props.svg]) return null
  const Shape = shapes[props.svg]

  return <Shape style={props.style} {...props} theme={theme} />
}
